import { Button, Card, CardActions, CardContent, Step, StepLabel, Stepper } from "@mui/material";
import React, { useState } from "react";
import { IFinanceStepperProps } from "../constants/FinanceModels";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import FinanceDialog from "./FinanceDialog";

const FinanceStepper = (props: IFinanceStepperProps) => {

    const [modalOpen, setModalOpen] = useState(false);

    const [activeStep, setActiveStep] = useState(0);

    const activeStepProps = props.steps[activeStep];


    const handleNext = () => {
        if (activeStep === (props.steps.length - 1)) return;
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        if (activeStep === 0) return;
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };


    return (
        <>
            <Stepper activeStep={activeStep}>
                {props.steps.map((step, index) => {
                    let stepProps: { completed?: boolean; } = {};

                    return (
                        <Step key={index} {...stepProps}>
                            <StepLabel>{step.label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            <Card variant="outlined" sx={{ height: '100%', margin: '5px' }}>
                <CardContent>
                    {props.steps[activeStep].content}
                </CardContent>
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                    {activeStepProps.actionResetTitle &&
                        <Button color={'accent'} variant={'outlined'} onClick={() => {
                            handleReset();
                            activeStepProps.actionResetCallback?.call({});
                        }}>{activeStepProps.actionResetTitle}</Button>
                    }
                    {activeStepProps.actionPreviousTitle &&
                        <Button color={'accent'} variant={'outlined'} onClick={() => {
                            handleBack();
                            activeStepProps.actionPreviousCallback?.call({});
                        }}>{activeStepProps.actionPreviousTitle}</Button>
                    }
                    {activeStepProps.actionContinueTitle &&
                        <Button disabled={activeStepProps.actionContinueAccessible === false} color={'accent'} variant={'contained'} onClick={() => {
                            if (activeStepProps.actionContinueModal === undefined) {
                                handleNext();
                                activeStepProps.actionContinueCallback?.call({});
                            } else {
                                if(activeStepProps.actionContinueModalNeeded) {
                                    activeStepProps.actionContinueModalNeeded().then(needed => {
                                        if(needed) {
                                            handleNext();
                                            activeStepProps.actionContinueCallback?.call({});
                                        } else {
                                            setModalOpen(true);
                                        }
                                    });
                                } else {
                                    setModalOpen(true);
                                }
                            }
                        }}>{activeStepProps.actionContinueTitle}</Button>
                    }
                </CardActions>
            </Card>
            {activeStepProps.actionContinueModal &&
                <FinanceDialog open={modalOpen}
                               onClose={() => setModalOpen(false)}
                               onCancel={() => {
                                   activeStepProps.actionContinueModal?.cancelCallback?.call({});
                               }}
                               callback={() => {
                                   handleNext()
                                   setModalOpen(false);
                                   activeStepProps.actionContinueCallback?.call({});
                               }}
                               title={activeStepProps.actionContinueModal.title}
                               content={activeStepProps.actionContinueModal.content}
                               cancelButton={activeStepProps.actionContinueModal.cancelButton}
                               confirmButton={activeStepProps.actionContinueModal.confirmButton}
                               titleIcon={<WarningRoundedIcon color={"info"}/>}
                />
            }
        </>
    );
}
export default FinanceStepper;